import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { omit } from '@elliemae/ds-utilities/utils';
import { ToolbarTrigger } from './ToolbarTrigger.js';
import { RowSizes } from '../../rowSizes.js';
import 'styled-components';
import '@elliemae/ds-basic/Button';
import '@elliemae/ds-icons/MoreOptionsVert';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var RowRenderer = function RowRenderer(Row, grid) {
  var Wrapped = function Wrapped(props) {
    var ref = useRef();
    var _props$rowData = props.rowData,
        rowData = _props$rowData === void 0 ? {} : _props$rowData,
        index = props.index,
        rowIndex = props.rowIndex,
        style = props.style;

    var _grid$getInstance = grid.getInstance(),
        wrapText = _grid$getInstance.props.wrapText;

    var _useState = useState({}),
        _useState2 = _slicedToArray(_useState, 2),
        popStyle = _useState2[0],
        setPopStyle = _useState2[1];

    var _useState3 = useState(style),
        _useState4 = _slicedToArray(_useState3, 2),
        rowStyle = _useState4[0],
        setRowStyle = _useState4[1];

    var gridInstance = grid.getInstance();
    var refs = gridInstance.refs,
        isRowDragging = gridInstance.isRowDragging;

    var _useState5 = useState(refs.body.current && refs.body.current.offsetWidth > refs.body.current.clientWidth),
        _useState6 = _slicedToArray(_useState5, 2),
        hasVerticalScrollBar = _useState6[0],
        setHasVerticalScrollBar = _useState6[1];

    useEffect(function () {
      var shouldOmit = isRowDragging ? ['top'] : [];
      setPopStyle(_objectSpread(_objectSpread({}, popStyle), {
        top: style && !isRowDragging ? style.top : '0'
      }));

      if (style) {
        // style defined means it has virtualization
        setHasVerticalScrollBar(true);
      } else {
        setHasVerticalScrollBar(false);
      }

      setRowStyle(omit(style || {
        height: !wrapText ? RowSizes[gridInstance.props.rowSize] : 'auto',
        position: 'relative'
      }, [shouldOmit]));
    }, [style, isRowDragging]);
    return /*#__PURE__*/React.createElement("div", {
      className: "row-renderer-fixed-height",
      style: {
        height: !wrapText ? RowSizes[gridInstance.props.rowSize] : 'auto',
        position: style ? 'auto' : 'relative' // top: isDragging ? rowStyle.top - RowSizes[gridInstance.props.rowSize] : 'auto',

      }
    }, /*#__PURE__*/React.createElement(Row, _extends({
      ref: ref
    }, props, {
      style: rowStyle
    })), isEmpty(rowData) && !rowData.index && !rowData.rowIndex ? null : /*#__PURE__*/React.createElement("div", {
      className: "toolbar-trigger-container ".concat(style ? 'move' : 'stay'),
      style: _objectSpread({}, popStyle)
    }, /*#__PURE__*/React.createElement(ToolbarTrigger, {
      grid: grid,
      rowData: {
        rowData: rowData,
        index: index,
        rowIndex: rowIndex
      },
      hasScrollBar: hasVerticalScrollBar,
      rowRef: ref
    })));
  };

  Wrapped.propTypes = {
    rowData: PropTypes.any,
    index: PropTypes.number,
    rowIndex: PropTypes.number,
    style: PropTypes.any
  };
  return Wrapped;
};

export { RowRenderer };
//# sourceMappingURL=RowRenderer.js.map
